import { createAction, props } from '@ngrx/store';
import { SitewideEntity } from '../../models/shared/sitewide.entities';

// Status Tracker
export const loadStatusTracker = createAction(
  '[Status Tracker/API] Load Status Tracker'
);

export const loadStatusTrackerSuccess = createAction(
  '[Status Tracker/API] Load Status Tracker Data Success',
  props<{ tracker: SitewideEntity }>()
);

export const loadStatusTrackerFailure = createAction(
  '[Status Tracker/API] Load Status Tracker Data Failure',
  props<{ error: SitewideEntity }>()
);

//-- AEM Content
export const loadAEMContent = createAction(
  '[Status Tracker/AEM] Load AEM Common Content'
);

export const loadAEMContentSuccess = createAction(
  '[Status Tracker/AEM] Load AEM Common Content Success',
  props<{ aemStatusTracker: SitewideEntity }>()
);

export const loadAEMContentFailure = createAction(
  '[Status Tracker/AEM] Load AEM Common Content Failure',
  props<{ error: SitewideEntity }>()
);

//-- AEM Summary Content
export const loadAEMSummaryContent = createAction(
  '[Status Tracker Summary/AEM] Load AEM Summary Content'
);

export const loadAEMSummaryContentSuccess = createAction(
  '[Status Tracker Summary/AEM] Load AEM Summary Content Success',
  props<{ aemStatusTrackerSummaryContent: SitewideEntity }>()
);

export const loadAEMSummaryContentFailure = createAction(
  '[Status Tracker Summary/AEM] Load AEM Summary Content Failure',
  props<{ error: SitewideEntity }>()
);

//-- Future activities
export const loadFutureActivity = createAction(
  '[Status Tracker Future Activity/API] Load FutureActivities'
);

export const loadFutureActivitySuccess = createAction(
  '[Status Tracker Future Activity/API] Load FutureActivities Success',
  props<{ futureActivities: SitewideEntity }>()
);

export const loadFutureActivityFailure = createAction(
  '[Status Tracker Future Activity/API] Load FutureActivities Failure',
  props<{ error: SitewideEntity }>()
);

//-- AEM Error Messages
export const loadAEMErrorMessages = createAction(
  '[Status Tracker ErrorMessages/AEM] Load AEM Error Messages'
);

export const loadAEMErrorMessagesSuccess = createAction(
  '[Status Tracker ErrorMessages/AEM] Load AEM Error Messages Success',
  props<{ aemErrorMessages: SitewideEntity }>()
);

export const loadAEMErrorMessagesFailure = createAction(
  '[Status Tracker ErrorMessages/AEM] Load AEM Error Messages Failure',
  props<{ aemErrorMessagesError: SitewideEntity }>()
);
